export default __webpack_public_path__ + "static/logos-tiles-bar-s-584ab5346cc907a05f0bb11cb4552490.svg";